export default __webpack_public_path__ + "static/media/kitchen4-afterA-1440w.f3d8a4a6.png";